<a href="/">
  <app-internal-icon
    [name]="name"
    [width]="width"
    [height]="height"
  ></app-internal-icon>
</a>
